module.exports = __webpack_public_path__ + "img/caja-vacia.95e88bf2.svg";